import axios from "axios"
import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom"
import { Divider, Icon, Label, Placeholder } from "semantic-ui-react"
import { useMyGlobal } from "./GlobalData"
import { BsBookmarkStar } from "react-icons/bs";
import slugify from 'slugify';
import { FaPeopleGroup } from "react-icons/fa6";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css/navigation';


const CategoryMain = () => {
    const navigate = useNavigate()
    const { token, categoryData, windowWidth } = useMyGlobal()
    const itemsPerCarousel = windowWidth < 768 ? 3 : 6;
    const swiperRef = useRef(null);
    const [isHover, setIsHover] = useState(false);

    const handleClickParent = (data) => {
        const par = {
            ...data,
            from: 'parent',
            selected_child: 0
        }

        const slug = slugify(par.category_name)

        navigate(`/product_list/${par.id_category}/${slug}`, {
            state: par
        })
    }

    const displayData =
    categoryData.length < 12
        ? [...categoryData, ...categoryData]
        : categoryData;

    return (
        
        <Container fluid className="mt-5 mb-4">
            <React.Fragment>
                <Row>
                    <Col md={12} className="text-start">
                        <div className="text-center">
                            <BsBookmarkStar className="fs-2"/>
                            <Divider horizontal>
                                <h1 className="fs-6">Shop by brand</h1>
                            </Divider>
                        </div>
                    </Col>
                </Row>

                <div
                    className="mt-3"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        position: 'relative',
                        padding: windowWidth < 768 ? '0' : '0 50px'
                        
                    }}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                >

                    {/* LEFT */}
                    {windowWidth >= 768 && (
                        <div
                            style={{
                                position: 'absolute',
                                left: '0px',
                                top: '50%',
                                transform: isHover 
                                            ? 'translateY(-50%) translateX(0)' 
                                            : 'translateY(-50%) translateX(-10px)',
                                zIndex: 10,

                                opacity: isHover ? 1 : 0,
                                transition: '0.3s',

                                cursor: 'pointer',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                            }}
                            onClick={() => swiperRef.current?.slidePrev()}
                        >
                            <FaChevronLeft size={20} />
                        </div>
                    )}

                    {/* SWIPER */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <Swiper
                            modules={[Autoplay]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            loop={true}
                            slidesPerGroup={1}
                            spaceBetween={16}
                            grabCursor={true}


                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true
                            }}

                            breakpoints={{
                                0: { slidesPerView: 3 },
                                768: { slidesPerView: 6 }
                            }}

                            speed={800}
                            
                            style={{ width: '100%' }}
                            slidesOffsetBefore={16}
                            slidesOffsetAfter={16}
                        >
                            {
                                displayData.length > 0 ? (
                                    displayData.map((item, i) => (
                                        <SwiperSlide key={`${item.id_category}-${i}`}>
                                            <div style={{paddingTop: "1.3em", paddingBottom: "1.5em", paddingLeft :"0rem", paddingRight :"0rem"}}>
                                                <Card
                                                    onClick={() => handleClickParent(item)}
                                                    style={{ cursor: 'pointer', alignContent: 'center' }}
                                                    className="zoom-2"
                                                >
                                                    <Image
                                                        rounded
                                                        src={item.thumbnail_image ? item.thumbnail_image : 'https://via.placeholder.com/350x600.png'}
                                                        fluid
                                                    />
                                                </Card>
                                            </div>
                                        </SwiperSlide>
                                    ))
                                ) : (
                                    [...Array(itemsPerCarousel)].map((_, i) => (
                                        <SwiperSlide key={i}>
                                            <Card style={{ alignContent: 'center' }}>
                                                <div
                                                    className="w-100"
                                                    style={{ aspectRatio: '350 / 600' }}
                                                >
                                                    <Placeholder fluid style={{ width: '100%', height: '100%' }}>
                                                        <Placeholder.Image rectangular />
                                                    </Placeholder>
                                                </div>
                                            </Card>
                                        </SwiperSlide>
                                    ))
                                )
                            }
                        </Swiper>
                    </div>

                    {/* RIGHT ARROW */}
                    {windowWidth >= 768 && (
                        <div
                            style={{
                                position: 'absolute',
                                right: '0px',
                                top: '50%',
                                transform: isHover 
                                            ? 'translateY(-50%) translateX(0)' 
                                            : 'translateY(-50%) translateX(10px)',
                                zIndex: 10,

                                opacity: isHover ? 1 : 0,
                                transition: '0.3s',

                                cursor: 'pointer',
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                            }}
                            onClick={() => swiperRef.current?.slideNext()}
                        >
                            <FaChevronRight size={20} />
                        </div>
                    )}

                </div>
            </React.Fragment>
        </Container>
        
    )
}

export default CategoryMain;